import SelectedDevicesList from './SelectedDevicesList';

export default SelectedDevicesList;
